/**
 * Central data-testid registry so identifiers stay consistent and unique.
 */
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const SHELL = {
  root: "app-shell",
  skipLink: "skip-to-content",
  sidebar: "app-sidebar",
  sidebarToggle: "sidebar-toggle",
  collapseToggle: "sidebar-collapse-toggle",
  topbar: "app-topbar",
  content: "app-content",
  wordmark: "brand-wordmark",
  pageTitle: "topbar-page-title",
  workspaceSwitcher: "workspace-switcher",
  resaButton: "resa-launcher",
  mobileNav: "mobile-nav",
  mobileMore: "mobile-nav-more",
  navItem: (key) => `nav-item-${key}`,
  mobileNavItem: (key) => `mobile-nav-${key}`,
};

export const FOUNDATION = {
  page: "foundation-page",
  colorSwatch: (token) => `color-swatch-${token}`,
  buttonSample: (variant) => `button-sample-${variant}`,
  stateBlock: (state) => `state-block-${state}`,
};

export const MODULE = {
  page: (key) => `module-page-${key}`,
};

export const AUTH = {
  signinPage: "signin-page",
  signupPage: "signup-page",
  forgotPage: "forgot-password-page",
  resetPage: "reset-password-page",
  verifyPage: "verify-email-page",
  email: "auth-email-input",
  password: "auth-password-input",
  confirmPassword: "auth-confirm-password-input",
  firstName: "auth-first-name-input",
  lastName: "auth-last-name-input",
  submit: "auth-submit-button",
  error: "auth-error",
  success: "auth-success",
  toSignup: "link-to-signup",
  toSignin: "link-to-signin",
  toForgot: "link-to-forgot",
  logout: "logout-button",
  userMenu: "user-menu",
};

export const APP = {
  authedFoundation: "authed-foundation",
  adminPage: "admin-foundation",
  protectedLoading: "protected-loading",
};
